module.exports = __webpack_public_path__ + "components/flag/static/square/er-cfdae6f7c4be7f548c9e71ee40480577.svg";